import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  GetCharge,
  ActiveCharge,
  InactiveCharge,
} from "../../../store/charge-store/charge-actions";
import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";

const ChargeDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const charge = useSelector((state) => state.charge.charge);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (charge.id === undefined || charge.id === 0) {
      dispatch(GetCharge(param.chargeId, userInfo.Email));
    }
  }, [param.chargeId,  dispatch, charge.id, userInfo.Email]);

  const activeHandler = () => {
    dispatch(ActiveCharge(param.chargeId, userInfo.Email));
  };
  const inactiveHandler = () => {
    dispatch(InactiveCharge(param.chargeId, userInfo.Email));
  };
  let activeSuspend;
  if (
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("charge.active")
  ) {
    activeSuspend = (
      <Button
        rounded
        text
        raised
        style={{ backgroundColor: "#fff", marginLeft: "1%", width: "150px" }}
        label="Activar"
        className="p-button-success"
        onClick={activeHandler}
        icon={
          notification && notification.status === "pending"
            ? "pi pi-spin pi-spinner"
            : "pi pi-check"
        }
        disabled={notification && notification.status === "pending"}
      />
    );
  }
  if (charge.status) {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("charge.inactive")
    ) {
      activeSuspend = (
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", marginLeft: "1%", width: "150px" }}
          label="Suspender"
          className="p-button-warning"
          onClick={inactiveHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-times"
          }
          disabled={notification && notification.status === "pending"}
        />
      );
    }
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {(charge.id === undefined || charge.id <= 0) && (
          <>
            <Loading />
          </>
        )}
        {(charge.id !== undefined || charge.id > 0) && (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
              height: "auto",
            }}
          >
            <div
              className="user-info text-center"
              style={{ borderBottom: "solid #fff", paddingBottom: "1.3%" }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {charge.name}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                Cargo
              </span>
            </div>
            <div className="formgrid grid mt-3">
              <div className="field col-12 md:col-12">
                <>
                  <label
                    style={{
                      color: "#",
                      fontSize: "large",
                      fontWeight: "bold",
                    }}
                  >
                    Descripción:{" "}
                  </label>
                  <label
                    style={{
                      color: "",
                      marginLeft: "1%",
                      fontSize: "large",
                    }}
                  >
                    {" "}
                    {charge.description}
                  </label>
                </>
              </div>
              <div className="field col-12 md:col-4 mt-3">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "150px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/charges");
                  }}
                />
              </div>
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("charge.edit") && (
                  <div className="field col-12 md:col-4 mt-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{
                        backgroundColor: "#fff",
                        marginLeft: "1%",
                        marginTop: "1%",
                        width: "150px",
                      }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/charges/edit/${charge.id}`);
                      }}
                    />
                  </div>
                )}
              <div className="field col-12 md:col-4 mt-3">{activeSuspend}</div>
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
export default ChargeDetail;
